import {useMutation} from "@tanstack/react-query"

import api from "../services"

export const useRollbackImporterMutation = () =>
  useMutation({
    mutationFn: (importerId: number) => api.importers.rollbackDelete(importerId),
  })
